import  {Map} from 'immutable'

export const companiesOverview = (state) => state.get('company', Map())



// JS
export const getPaymentStatus = (company) => {
    let payment_status = company.payment_status
    if(payment_status['status'] !== undefined){
        return payment_status['status']
    }
    return payment_status
}



// WEBPACK FOOTER //
// src/selectors/company.js